module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('ul', {
    staticClass: "preview-ul"
  }, [_c('li', {
    staticClass: "form-line"
  }, [_c('div', {
    staticClass: "form-line-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("booking.index.checkin")) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.booking.checking ? _vm.booking.checking : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "form-line-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("booking.index.checkout")) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.booking.checkout ? _vm.booking.checkout : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "form-line-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("input.number_of_adults")) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.booking.nbr_adults ? _vm.booking.nbr_adults : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "form-line-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("input.number_of_children")) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.booking.nbr_children ? _vm.booking.nbr_children : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "form-line-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("booking.index.guest")) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.booking.guest.first_name && _vm.booking.guest.last_name ? ((_vm.booking.guest.first_name) + " " + (_vm.booking.guest.last_name)) : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "form-line-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("input.arrival_time")) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.booking.time_in ? _vm.booking.time_in : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "form-line-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("input.departure_time")) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.booking.time_out ? _vm.booking.time_out : '-'))])])]), _vm._v(" "), _c('li', {
    staticClass: "form-line"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checkin-form-email"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("input.email")) + "\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.guest.alternative_email),
      expression: "booking.guest.alternative_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "checkin-form-email"
    },
    domProps: {
      "value": (_vm.booking.guest.alternative_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking.guest, "alternative_email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "form-line"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checkin-form-phone"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("input.phone")) + "\n            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.guest.alternative_phone),
      expression: "booking.guest.alternative_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "checkin-form-phone"
    },
    domProps: {
      "value": (_vm.booking.guest.alternative_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking.guest, "alternative_phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "form-line"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checkin-form-time-in"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("input.checkin_time")) + "\n            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.time_in),
      expression: "booking.time_in"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "checkin-form-time-in"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "time_in", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.timeInHours), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i))])
  }))])]), _vm._v(" "), _c('li', {
    staticClass: "form-line"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checkin-form-timeout"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("input.checkout_time")) + "\n            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.time_out),
      expression: "booking.time_out"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "checkin-form-timeout"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "time_out", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.timeOutHours), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i))])
  }))])]), _vm._v(" "), _c('li', {
    staticClass: "form-line"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checkin-form-comments"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("booking.detail.events.comments")) + "\n            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), (_vm.booking.extra_data_from_form) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.extra_data_from_form.comments),
      expression: "booking.extra_data_from_form.comments"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "checkin_form_comment",
      "id": "checkin-form-comments",
      "cols": "100",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.booking.extra_data_from_form.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking.extra_data_from_form, "comments", $event.target.value)
      }
    }
  }) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05144eb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/form/show/checkin-form/FormDetails.vue
// module id = 1327
// module chunks = 0